import { createFileRoute } from '@tanstack/react-router';
import Checkout from 'src/pages/Organization/Event/Checkout';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/checkout',
)({
  component: Checkout,
});
